import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20artistic%20illustration%20banner%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20modern%20comic%20panels%20with%20diverse%20characters%2C%20abstract%20geometric%20patterns%2C%20soft%20gradient%20atmosphere%2C%20elegant%20minimal%20design%2C%20storytelling%20visual%20style%2C%20no%20text%2C%20clean%20artistic%20composition&width=1600&height=900&seq=hanman-hero-bg&orientation=landscape"
        alt="韩漫在线阅读网 - 韩国漫画免费看"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/90 text-background-50 text-sm font-medium mb-6 backdrop-blur-sm">
          全网韩漫 免费阅读
        </span>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 max-w-4xl leading-tight">
          韩国漫画免费看，精彩韩漫
          <br className="hidden md:block" />
          尽在韩漫在线阅读网
        </h1>
        <p className="text-base md:text-lg text-background-100/80 max-w-2xl mb-8 leading-relaxed">
          全网韩漫全集同步更新，第一时间获取最新连载章节。
          恋爱、奇幻、校园等多种类型热门韩漫推荐，
          为每一位韩漫爱好者打造最优质的免费阅读体验。
        </p>
        <div className="flex items-center gap-4 flex-col sm:flex-row">
          <Link
            to="/"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即阅读
          </Link>
          <a
            href="#featured"
            className="px-8 py-3 rounded-full border border-background-50/40 text-background-50 font-medium text-base hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            精选推荐
          </a>
        </div>

        <div className="mt-12 flex items-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">500+</div>
            <div className="text-xs md:text-sm text-background-100/60 mt-1">韩漫资源</div>
          </div>
          <div className="w-px h-10 bg-background-100/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">50万+</div>
            <div className="text-xs md:text-sm text-background-100/60 mt-1">忠实读者</div>
          </div>
          <div className="w-px h-10 bg-background-100/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-bold text-background-50">每日</div>
            <div className="text-xs md:text-sm text-background-100/60 mt-1">同步更新</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-6 flex items-center justify-center animate-bounce">
          <i className="ri-arrow-down-s-line text-background-50/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}